// src/App.tsx
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AuthContext, firebaseUserStats } from './_services/firebase'
import { RequireAuth } from './guards/RequireAuth'
import { PublicOnly }  from './guards/PublicOnly'

import Login   from './pages/Login/Login'
import Home    from './pages/Home/Home'
import PinGate from './components/PinGate/PinGate'
import GlobalToast from './components/Toast/GlobalToast'

export default function App() {
  const { currentUser, setCurrentUser } = React.useContext(AuthContext)
  const [pinOk, setPinOk] = React.useState(false)

  // track auth state
  React.useEffect(() => {
    return firebaseUserStats((user) => {
      setCurrentUser(user ?? null)
      if (!user) setPinOk(false)
    })
  }, [setCurrentUser])

  // reset pin ถ้าเปลี่ยน user
  React.useEffect(() => {
    setPinOk(false)
  }, [currentUser?.uid])

  return (
    <>
      <GlobalToast />
      <Routes>
        <Route path='/' element={<Navigate to='/home' replace />} />

        <Route
          path='/login'
          element={
            <PublicOnly>
              <Login />
            </PublicOnly>
          }
        />

        <Route
          path='/home'
          element={
            <RequireAuth>
              {pinOk
                ? <Home uid={currentUser?.uid || ''} />
                : <PinGate uid={currentUser?.uid || ''} onPassed={() => setPinOk(true)} />
              }
            </RequireAuth>
          }
        />

        <Route path='*' element={<Navigate to='/home' replace />} />
      </Routes>
    </>
  )
}
